import { showDeleteConfirmation } from '@modules/common';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { switchMap, tap } from 'rxjs/operators';
import { SenderResponse, SenderID } from '@business/entities/sender';
import { EmailSenderAPI } from '@business/api/emailSender';

export class SenderBloc extends BaseBloc {
  private readonly senderRepo = new Repository<SenderResponse>({
    getItemId: category => category.id,
  });

  readonly senders$ = this.senderRepo.items$;

  onReset() {
    this.senderRepo.reset();
  }

  fetchSenders = () => {
    return EmailSenderAPI.fetchSenders().pipe(this.senderRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_email_senders') }));
  };

  createSender = (data: Partial<SenderResponse>) => {
    return EmailSenderAPI.createSender(data).pipe(
      this.senderRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_email_sender'),
      }),
    );
  };

  updateSender = (id: SenderID, data: Partial<SenderResponse>) => {
    return EmailSenderAPI.updateSender(id, data).pipe(
      this.senderRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_email_sender'),
      }),
    );
  };

  makeDefault = (id: SenderID) => {
    return EmailSenderAPI.makeDefault(id).pipe(
      this.senderRepo.ops.reset(),
      handleMessage({
        type: requestMessage('update_email_sender'),
      }),
    );
  };

  deleteSender = (id: SenderID) => {
    return showDeleteConfirmation('Delete Category', 'Do you really want to remove this category').pipe(
      switchMap(() => EmailSenderAPI.deleteSender(id)),
      this.senderRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_email_sender'),
      }),
    );
  };
}
